exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#checkin[data-v-24931748]{padding-top:100px}.sub-heading[data-v-24931748]{color:#000!important}#signature[data-v-24931748]{margin:auto;border:3px solid #000;border-radius:5px;background-origin:border-box;background-clip:content-box,border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-24931748","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Reservas/Webchecking.vue
// module id = 696
// module chunks = 2